import React, { useEffect, useState } from 'react';
import { useRouter } from '../../hooks/router';
import { useApiQuery } from '@orderx/lab/xr/http';
import { UiFlex, UiGrid } from '@open-stack/ui';
import { ZoneView } from '../../components/zone-view/ZoneView';
import { apiPublicTagIdGet } from '../../api/public.tag.{id}.[get]';
import { TagType } from '../../XV2';
import { XOverlay } from '../../components/x/overlay/XOverlay';
import styled from 'styled-components';
import { TagOutlet } from '../../components/tag/outlet/TagOutlet';
import { TagOutletGroupToZone } from '../../components/tag/outlet-group-to-zone/TagOutletGroupToZone';
import { TagOutletGroup } from '../../components/tag/outlet-group/TagOutletGroup';
import { BrowsePage } from '../browse/BrowsePage';
import { TagDiscountClaim } from '../../components/tag/discount-claim/TagDiscountClaim';
import { TagMenuOutletProductsShow } from '../../components/tag/menu-products-show/TagMenuOutletProductsShow';
import { XRouterRedirect } from '../../components/x/router/redirect/XRouterRedirect';
import { Environment } from '../../environment';
import { XInput } from '../../components/x/input/XInput';
import { XButton } from '../../components/x/button/XButton';
import { XText, XTextType } from '../../components/x/text/XText';
import { LocationPage } from '../location/LocationPage';
import { TagCovidRegistration } from '../../components/tag/covid-registration/TagCovidRegistration';

const Wrapper = styled(UiFlex)`
    position: fixed;
    height: 100%;
    width: 100%;
    z-index: 1;

    .UiButton {
        padding: 0 calc(4 * var(--ui-spacing));
    }
`;

export function RootIdPage() {
    const {
        replaceParams,
        params: { id },
    } = useRouter();

    const [tagName, setTagName] = useState('');

    const { run, response, isLoading, reset } = useApiQuery(() =>
        apiPublicTagIdGet({
            params: { id },
        }),
    );

    useEffect(() => {
        run();
    }, [id]);

    if (!id) {
        return <XRouterRedirect pageOrPath={BrowsePage} />;
    }

    if (!response) {
        return <XOverlay type="loading" />;
    }

    if (response.action === TagType.ZONE) {
        return <XRouterRedirect pageOrPath={RootIdPage} params={{ id: response.zoneHash }} />;
    }

    if (response.action === TagType.OUTLET) {
        return <TagOutlet {...response} />;
    }

    if (response.action === TagType.OUTLET_GROUP_TO_ZONE) {
        return <TagOutletGroupToZone {...response} />;
    }

    if (response.action === TagType.OUTLET_GROUP) {
        return <TagOutletGroup {...response} />;
    }

    if (response.action === TagType.DISCOUNT_CLAIM) {
        return <TagDiscountClaim {...response} />;
    }

    if (response.action === TagType.OUTLETS_PRODUCTS_SHOW) {
        return <TagMenuOutletProductsShow {...response} />;
    }

    if (response.action === TagType.COVID_REGISTRATION) {
        return <TagCovidRegistration {...response} />;
    }

    if (response.type === 'LEGACY') {
        window.location.href = `${Environment.V1_PUBLIC_PATH}/${id}`;
    }

    const { zone, location } = response;

    if (location) {
        return <XRouterRedirect pageOrPath={LocationPage} params={{ locationId: location.id }} />;
    }

    if (zone) {
        return <ZoneView zone={zone} />;
    }

    return (
        <Wrapper fullHeight padding={4} justifyContent="center">
            <UiGrid gap={4}>
                <XText type={XTextType.TITLE} align="center">
                    Nothing interesting found! <br />
                    Try scanning a QR code or enter table name
                </XText>

                <XInput
                    value={tagName}
                    onChangeValue={setTagName}
                    placeholder="Enter table name"
                    adornmentEnd={
                        <XButton
                            onClick={() => {
                                reset();
                                setTagName('');
                            }}
                            to={replaceParams(RootIdPage.route, { id: tagName })}
                            isLoading={isLoading}
                            disabled={!tagName}
                            color="primary">
                            Go
                        </XButton>
                    }
                />
            </UiGrid>
        </Wrapper>
    );
}

RootIdPage.route = '/:id';
